// CustomerListTableWithDialog.jsx
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { Avatar, Box, Button, Chip, InputAdornment, Link, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import IconifyIcon from 'components/base/IconifyIcon';
import DataGridPagination from 'components/pagination/DataGridPagination';
import StyledTextField from 'components/styled/StyledTextField';

const Dispatch = () => {
  const navigate = useNavigate();

  const handleNivagation = (row) => {
    navigate('/dispatch-list', { state: row });
  };
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
    search: '',
  });
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPaginationModel((prev) => ({ ...prev, search }));
    }, 600);
    return () => clearTimeout(timeOut);
  }, [search]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // /list_customers
      const res = await post('users/list_customers_stages', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
        type: 'inventory',
      });
      if (res.status == 200) {
        setData(res.data.data);
        setTotal(res.data.total);
      } else {
        enqueueSnackbar(res.message || 'Error while Fetching Customer', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Fetching Customer', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  const getStatusBadgeColor = (val) => {
    switch (val) {
      case 'Dispatched':
        return 'success';
      case 'Full':
        return 'success';
      case 'Hold':
        return 'error';
      case 'InProgress':
        return 'info';
      case 'Partial':
        return 'info';
      case 'no':
        return 'error';
      default:
        return 'info';
    }
  };

  const columns = useMemo(
    () => [
      {
        field: 'client',
        headerName: 'Client',
        minWidth: 240,
        flex: 1,
        renderCell: (params) => {
          const { firstName, lastName, mobile } = params.row;
          return (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar
                alt={firstName.toUpperCase()}
                src={`${firstName} ${lastName}`}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <Box>
                <Typography variant="subtitle2">{`${firstName} ${lastName}`}</Typography>
                <Link href="#!" variant="caption">
                  {mobile || ''}
                </Link>
              </Box>
            </Stack>
          );
        },
      },
      {
        field: 'status',
        headerName: 'Status',
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          const status = params?.row?.dispatchStatus;
          return (
            <Stack>
              <Chip
                label={status || '-'}
                variant="soft"
                color={getStatusBadgeColor(status)}
                sx={{ textTransform: 'capitalize' }}
              />
            </Stack>
          );
        },
      },
      {
        field: 'material',
        headerName: 'Material',
        minWidth: 150,
        flex: 1,
        renderCell: (params) => (
          <Stack>
            <Chip
              label={params?.row?.dispatchType || '-'}
              variant="soft"
              color={getStatusBadgeColor(params?.row?.dispatchType)}
              sx={{ textTransform: 'capitalize' }}
            />
          </Stack>
        ),
      },
      {
        field: 'installation',
        headerName: 'Installation CheckList',
        width: 150,
        flex: 1,
        sortable: false,
        renderCell: (params) => (
          // <Link variant="body2" sx={{ fontWeight: 400 }} href="/dispatch-list">
          <Button variant="outlined" size="small" onClick={() => handleNivagation(params.row)}>
            Update
          </Button>
          // </Link>
        ),
        //  onClick={() => handleOpenDialog(params.row)}
      },
      // {
      //   field: 'action',
      //   headerName: 'Action',
      //   sortable: false,
      //   align: 'right',
      //   width: 60,
      //   headerAlign: 'right',
      //   renderCell: () => <DashboardMenu />,
      // },
    ],
    [],
  );

  return (
    <>
      <Box sx={{ width: '100%', p: { xs: 3, md: 5 } }}>
        <StyledTextField
          id="search-box"
          type="search"
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search Customer"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            maxWidth: { sm: 200, md: 240 },
            flexGrow: { xs: 1, sm: 0 },
            mb: 3,
          }}
        />
        <DataGrid
          loading={loading}
          rowHeight={72}
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationMode="server"
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={(e) =>
            setPaginationModel({ page: e.page, pageSize: e.pageSize, search })
          }
          pageSizeOptions={[5, 10, 20]}
          sx={{
            '& .margin': {
              pr: 3,
            },
            '& .MuiDataGrid-columnHeaders': {
              minWidth: '100%',
            },
          }}
          slots={{
            basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
          }}
        />
      </Box>
    </>
  );
};

export default Dispatch;
